<template>
  <div class>
    <drawer :title="addEditTitle" :dialogShow="addEditShow" @handleChange="handleChangeDrawer">
      <div slot="body">
      
        <div class="pay-mains">
          <div class="set_data_main">
            <div class="list_box white" v-for="item,index in list" :key="index">
              <div class="align-items mb10">
                <div class="fb">开始日期</div>
                <div class="color666">
                  <el-date-picker v-model="item.beginTime" value-format="yyyy-MM-dd" :default-value="defaultValue" :picker-options="pickerOptions" type="date" placeholder="选择日期"></el-date-picker>
                </div>
              </div>
              <div class="align-items mb10">
                <div class="fb">结束日期</div>
                <div class="color666">
                  <el-date-picker v-model="item.endTime" value-format="yyyy-MM-dd" :default-value="defaultValue" :picker-options="pickerOptions" type="date" placeholder="选择日期"></el-date-picker>
                </div>
              </div>
              <div class="align-items mb10">
                <div class="fb">{{params.shopWorkType == 'cook' ? '配备厨师':'配备副店长'}} </div>
                <div><el-switch v-model="item.openFlag" active-color="#13ce66" inactive-color="#ccc" active-value="yes" inactive-value="no"></el-switch></div>
              </div>
              <div class="align-items" v-show="item.openFlag == 'yes'">
                <div class="fb">选择店员</div>
                <div class="primary-bg">
                  <el-select v-model="item.staffId" placeholder="请选择" @change="onClickStaff(item,index)">
                    <el-option
                      v-for="item in staffList"
                      :key="item.id"
                      :label="item.staffName"
                      :value="item.id">
                    </el-option>
                  </el-select>
                </div>
              </div>
              <div class="del-class cur" @click="delItem(index)">
                <img src="../../../assets/images/audit_refuse.png" alt="">
              </div>
            </div>
          </div>
          <div class="set_data_footer">
            提示：如果计算出来的补贴金额与实际情况不符，选择日期后可修改是否发放补贴或调整补贴人员。
          </div>
        </div>
        <div class="drawer-footer pr24 pb10">
          <div class="btns">
            <el-button type="success" class="small-btn" @click="addItem">新增</el-button>
            <el-button type="primary" class="small-btn" @click="onSubmit">保存</el-button>
          </div>
        </div>
      </div>
    </drawer>
  </div>
</template>

<script>
import minxin from "../../../assets/javascript/minxin.js";
import drawer from "../../../components/common/drawer";
import imgUpload from "../../../components/common/modules/upload";
export default {
  mixins: [minxin],
  components: { drawer, imgUpload },
  data() {
    return {
      addEditTitle: "修改补贴明细",
      addEditShow: false,
      list: [
        { beginTime: '', endTime: '', openFlag: 'no', staffId: '', staffName: '' }
      ],
      showDate: false,
      currentDate: '',
      currentEditIndex: null,
      currentTimeType: null,
      params: {
        shopWorkType: '',
        updateMonth: '',
        itemFormList: []
      },
      showPupup: false,
      staffList: [],
      defaultValue: new Date(),
      pickerOptions: {
        disabledDate: (time) => {
          // 如果函数处理比较简单,可以直接在这里写逻辑方法
          return this.dealDisabledDate(time)
        }
      }
    };
  },
  created() {
    
  },
  methods: {
    init (row) {
      this.list = [{ beginTime: '', endTime: '', openFlag: 'no', staffId: '', staffName: '' }];
      this.params = {
        shopWorkType: '',
        updateMonth: '',
        itemFormList: []
      }
      if (Object.keys(row).length > 0) {
        this.params = Object.assign(this.params, row)
        console.log(this.params);
        this.defaultValue = this.params.updateMonth || new Date()
      }
      this.addEditShow = true;
      this.companyStaffList()
    },
    dealDisabledDate (time) {
      let { monthStartDate, monthEndDate } = this.getStartDay(this.params.updateMonth)
      return (time.getTime() + 8.64e7 < new Date(monthStartDate).getTime() ||
        time.getTime() >= new Date(monthEndDate).getTime()
      )
    },
    addItem () {
      let obj = { beginTime: '', endTime: '', openFlag: 'no', staffId: '', staffName: '' }
      this.list.push(obj)
    },
    delItem (index) {
      this.list.splice(index, 1)
    },
    handleChangeDrawer () {
      this.addEditShow = false;
    },
    companyStaffList() {
      this.$api.post(this.$url.companyStaff.listAuthForData, {allFlag: false}).then(res => {
        if (res) {
          this.staffList = res;
        }
      }).catch(error => { });
    },
    onClickStaff (item, index) {
      console.log(item, index);
      let result = this.staffList.find(p => p.id == item.staffId).staffName
      if (result) item.staffName = result

    },
    onSubmit (values) {
      let flag = false;
      for (let i = 0; i < this.list.length; i++) {
        const e = this.list[i];
        if (!e.beginTime) {
          flag = true;
          this.$message.error("还有开始时间未选择");
          break;
        } else if (!e.endTime) {
          flag = true;
          this.$message.error("还有结束时间未选择");
          break;
        } else if (e.openFlag == "yes" && !e.staffId) {
          flag = true;
          this.$message.error("还有店员未选择");
          break;
        } 
      }
      if (flag) return
      this.params.itemFormList = this.list;
      this.$api.post(this.$url.shopWork.batchUpdate, this.params)
          .then(res => {
            if (res) {
              this.handleChangeDrawer();
              this.$message.success("保存成功");
              this.$emit("change", true);
            }
          })
          .catch(error => {});
      },
  }
};
</script>
<style scoped lang="less">

.pay-mains {
  padding: 10px 20px;
  box-sizing: border-box;
  .set_data_main {
    margin: 0 10px 0 10px;
    height: calc(100vh - 215px);
    overflow-y: auto;
  }
  .set_data_footer {
    margin: 10px;
  }
  .list_box {
    position: relative;
    padding: 20px 30px 20px 20px;
    border: 1px solid rgba(126,134,142);
    border-radius: 5px;
    margin-bottom: 12px;
    &:last-child {
      margin-bottom: 0;
    }
    .del-class {
      width: 24px;
      height: 24px;
      position: absolute;
      right: 0;
      top: 0;
      img {
        width: 100%;
        height: 100%;
      }
    }
  }
  .popup-title {
    text-align: center;
    font-size: 18px;
    font-weight: 700;
    padding: 14px 0;
    border-bottom: 1px solid #F6F6F6;
  }
  .popup-content {
    padding: 16px;
  }
  .popup-remark {
    width: 70%;
  }
  .popup-border {
    border-bottom: 1px solid rgba(17,31,44,0.12);
  }
  .popup-title {
    height: 22px;
    font-size: 18px;
    text-align: center;
  }
  .selected-staffNames {
  padding: 30px 16px;
}

.staff-listItem {
  height: 73px;
  overflow: hidden;
}
.selected-staffNames .staff-box {
  text-align: center;
  height: 33px;
  line-height: 33px;
  margin-bottom: 40px;
}
.selected-staffNames .active {
  width: 85px;
  background: #226bf6;
  color: #fff;
  border-radius: 17px;
}
}

</style>